import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions as uiActions } from '@elab/core/store/ui';
import { actions as cartActions, selectors as cartSelectors } from '@elab/core/store/cart';
import { actions as globalActions } from '@elab/core/store/global';
import withCookieData from '@elab/core/utils/hoc/withCookieData';

class NavigationConfirm extends SimpleLitElement {
    static get properties() {
        return {
            // From attributes
            dialogTitle: { type: String, attribute: 'dialog-title' },
            dialogDescription: {
                type: String,
                attribute: 'dialog-description',
            },
            dialogConfirm: { type: String, attribute: 'dialog-confirm' },
            dialogCancel: { type: String, attribute: 'dialog-cancel' },
            isEmptyCart: { type: Boolean, attribute: false },
            eGiftCardCartId: { type: String, attribute: false },
        };
    }

    constructor() {
        super();
        // Is eGift Card Cart Cookie set
        this.eGiftCardCartId = false;
        this.isEmptyCart = false;
        this.confirmUrl = '/';
    }

    afterConnect() {
        // if there's an eGift Card Cookie Set, hijack back links
        if (this.eGiftCardCartId) {
            this.customNavigation();
        }
    }

    disconnectedCallback() {
        if (this.eGiftCardCartId) {
            this.clearCustomNavigation();
        }
    }

    customNavigation() {
        // list of links to hijack
        this.backLinks = document.querySelectorAll('.header-logo__link, .e2-link.backlink');

        this.backLinks.forEach(btn => btn.addEventListener('click', this.showAbandonCartModal));
    }

    clearCustomNavigation() {
        this.backLinks.forEach(btn => btn.removeEventListener('click', this.showAbandonCartModal));
    }

    showAbandonCartModal = event => {
        event.preventDefault();

        // set confirm leave button to previously clicked location
        this.confirmUrl = event.currentTarget.getAttribute('href');

        // force modal open instead of links
        this.dispatchEvent(
            new CustomEvent('open-dialog', {
                detail: { name: 'navigation-confirm-dialog' },
            }),
        );
        return false;
    };

    confirmLeave() {
        this.dispatchEvent(new CustomEvent('disable-egift-card-cart'));
        this.clearCustomNavigation();
        this.dispatchEvent(new CustomEvent('close-dialog'));
        this.dispatchEvent(new CustomEvent('redirect', { detail: this.confirmUrl }));
    }

    render() {
        return html`
            <e2-dialog
                name="navigation-confirm-dialog"
                close-bg-click
                btn-close
                close-button-inside-dialog
                no-scroll
                close-button-class="icon-error"
                addClass="dialog-navigation-confirm"
            >
                <div class="navigation-confirm-dialog" slot="content">
                    <h1 class="navigation-confirm-dialog__title">
                        ${this.dialogTitle}
                    </h1>
                    <h3 class="navigation-confirm-dialog__subtitle">
                        ${this.dialogDescription}
                    </h3>

                    <div class="navigation-confirm-dialog__buttons">
                        <button
                            class="button button--primary button--text-center button--uppercase"
                            @click="${this.confirmLeave}"
                        >
                            ${this.dialogConfirm}
                        </button>

                        <e2-action-button
                            no-arrow
                            class-modifier="button--white button--uppercase"
                            action-type="UI.CLOSE_DIALOG"
                        >
                            ${this.dialogCancel}
                        </e2-action-button>
                    </div>
                </div>
            </e2-dialog>
        `;
    }
}

const mapDispatchToEvents = dispatch => {
    return {
        'close-dialog': () => dispatch(uiActions.closeDialog()),
        'open-dialog': ({ detail }) => dispatch(uiActions.openDialog(detail)),
        redirect: ({ detail }) => dispatch(globalActions.redirect(detail)),
        'disable-egift-card-cart': () =>
            dispatch(cartActions.restoreRegularCart({ shouldLoadCart: true })),
    };
};
const mapStateToProps = state => ({
    isEmptyCart: cartSelectors.isEmpty(state),
});

const cookieDataConfig = [
    {
        name: 'eGiftCardCartEnding',
        propName: 'eGiftCardCartId',
        withBaseSite: true,
        fromCookieNames: true,
    },
];

export default () =>
    customElements.define(
        'e2-navigation-confirm',
        connect(
            mapStateToProps,
            mapDispatchToEvents,
        )(withCookieData(cookieDataConfig)(NavigationConfirm)),
    );
